<div class="outer_div">
    <div class="square_shape">
        <img src="../../../assets/images/home_banner.jpg" alt="background">
        <div class="in_side_images">
        </div>
    </div>
</div>

<div class="academic-writing">
    <div class="container">
        <div class="row">
            <!-- data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" -->
            <div class="col-xl-8">
                <h1 class="main-title ">道地的文法和寫作</h1>
                <p>
                    <span class="OpenSansFonts">Trinka</span>是用於學術和技術寫作的最佳文法和語言校正的人工智慧工具</p>
                    <ul class="highted-points">
                    <li>
                        <span class="OpenSansFonts">3000</span>多項文法檢查</li>
                    <li>語調和風格增強</li>
                    <li>高級寫作技巧</li>
                    <li>適用於所有學科</li>
                </ul>
                <div class="col-md-12">
                    <div class="banner-btns">
                        <!-- no_hover -->
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">
                            <i class="fa fa-sign-in"></i> 免費註冊</a>
                        <!-- <div class="banner-btns-inner">
                            <a href="https://cloud.trinka.ai" target="_blank">
                                <div class="icons">
                                    <img src="../../../assets/images/Get_stated_online_icons.png" alt="Online start">
                                </div>
                                <div class="banner-txt">
                                    <span class="purple-text">開始提升寫作</span>
                                    <p>登錄<span class="OpenSansFonts">Trinka Cloud</span></p>
                                </div>
                            </a>
                        </div>
                        <div class="banner-btns-inner">
                            <a [routerLink]="['/wordplugin']">
                                <div class="icons">
                                    <img src="../../../assets/images/download_trinka_icon.png" alt="Download Trinka">
                                </div>
                                <div class="banner-txt">
                                    <span class="purple-text">即將上線！</span>
                                    <p>免費<span class="OpenSansFonts">Microsoft Word</span>外掛程式</p>
                                </div>
                            </a>
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" -->
            <div class="col-xl-4">
                <div class="technical-writing">
                    <div class="technical-writing-slider">
                        <section class="slide-wrapper">
                            <div class="hub-slider">
                                <div class="hub-slider-slides">
                                    <ul>
                                        <li>
                                            <div class="slider-card">
                                                <p>
                                                    <span>On the other hand</span>
                                                    <span class="themeColor">However</span>, additional factors
                                                    <span>which influence</span>
                                                    <span class="themeColor">influencing</span> patient prognosis and
                                                    <span>leading to a reduction in</span>
                                                    <span class="themeColor">reducing</span> HDL-C and Apo A1 levels were assessed.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Apo A1 levels
                                                    <span>are</span> appeared to
                                                    <span>negatively correlate
                                                    </span>
                                                    <span class="themeColor">correlate negatively</span> with hs-CRP levels [11], consistent with
                                                    our findings.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>This result
                                                    <span>may</span>
                                                    <span class="themeColor">may be</span>
                                                    <span>attribute</span>
                                                    <span class="themeColor">attributed to</span>
                                                    patients appendectomized for over 20 years being older than the controls.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                                    <span>transverse myelitis with long spinal cord lesions</span>
                                                    <span class="themeColor">longitudinally extensive transverse myelitis</span>.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>The
                                                    <span>retarded children</span>
                                                    <span class="themeColor">children with mental retardation</span> were taken to a different facility.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Utilities would continue to
                                                    <span>have the obligation</span>
                                                    <span class="themeColor">be obliged</span> to serve retail customers.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div class="hub-slider-controls">
                                    <button class="hub-slider-arrow hub-slider-arrow_next">
                                        <i class="fa fa-chevron-up"></i>
                                    </button>
                                    <button class="hub-slider-arrow hub-slider-arrow_prev">
                                        <i class="fa fa-chevron-down"></i>
                                    </button>
                                </div>

                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="for_mobile_contents">
    <div class="mobile_slider_overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000">
                <div class="academic_writing_section main_slider_homepage">
                    <div class="container">
                        <div class="academic_slider_section">
                            <div id="main_slider" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <p>
                                            <span>On the other hand</span>
                                            <span class="themeColor">However</span>, additional factors
                                            <span>which influence</span>
                                            <span class="themeColor">influencing</span> patient prognosis and
                                            <span>leading to a reduction in</span>
                                            <span class="themeColor">reducing</span> HDL-C and Apo A1 levels were assessed.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>Apo A1 levels
                                            <span>are</span> appeared to
                                            <span>negatively correlate</span>
                                            <span class="themeColor">correlate negatively</span> with hs-CRP levels [11], consistent with our findings.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>This result
                                            <span>may</span>
                                            <span class="themeColor">may be</span>
                                            <span>attribute</span>
                                            <span class="themeColor">attributed to</span>
                                            patients appendectomized for over 20 years, being older than the controls.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span>transverse myelitis with long spinal cord lesions</span>
                                            <span class="themeColor">longitudinally extensive transverse myelitis</span>.</p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>The
                                            <span>retarded children</span>
                                            <span class="themeColor">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>

                                    <div class="carousel-item">
                                        <p>Utilities would continue to
                                            <span>have the obligation</span>
                                            <span class="themeColor">be obliged</span> to serve retail customers.</p>
                                    </div>


                                    <a class="carousel-control-prev" href="#main_slider" data-slide="prev">
                                        <span>
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;"
                                                xml:space="preserve">
                                                <g>
                                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                    <a class="carousel-control-next" href="#main_slider" data-slide="next">
                                        <span>
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;"
                                                xml:space="preserve">
                                                <g>
                                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="academic_writing_section academic_background_shap">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="academic_writing_text">
                    <h2>專為學術和技術寫作而設計</h2>
                    <p>
                        <span class="OpenSansFonts">Trinka</span>能發現學術寫作特有的困難和錯誤，這是其他工具沒有的功能。從複雜的文法錯誤到學術寫作的語調和風格，
                        <span class="OpenSansFonts">Trinka</span>都能檢測出！</p>
                </div>
            </div>
        </div>

        <div class="academic_slider_section">
            <div id="subject-verb-d" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>發現其他工具找不出來的棘手錯誤</h3>
                    <p>
                        <span class="OpenSansFonts">Trinka</span>專為學術和技術寫作而設計，可以糾正
                        <span class="OpenSansFonts">3000</span>多種複雜的文法錯誤。現在，輕鬆寫作不再出現文法錯誤！</p>
                    <ul class="carousel-indicators">
                        <li data-target="#subject-verb-d" data-slide-to="0" class="active">
                            <span></span> 主語—動詞，代詞—前置詞分歧</li>
                        <li data-target="#subject-verb-d" data-slide-to="1">
                            <span></span>句法，單詞選擇</li>
                        <li data-target="#subject-verb-d" data-slide-to="2">
                            <span></span>代名詞，冠詞用法</li>
                        <li data-target="#subject-verb-d" data-slide-to="3">
                            <span></span>技術專有名詞的拼寫</li>
                    </ul>
                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>主語—動詞不一致</h4>
                        <p>Five different experts
                            <span>was</span>
                            <span class="themeColor">were</span> asked to evaluate the individual's performance and interobserver agreement was assessed.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>句法</h4>
                        <p>Rarely
                            <span class="themeColor">do</span> we use aneurysm clips to obliterate the vessels.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>代名詞，冠詞用法</h4>
                        <p>
                            <span>Every</span>
                            <span class="themeColor">Every one</span> of these studies claimed the importance of the spatial externalities for economic
                            growth.
                        </p>
                        <!-- <p>Other recombination reactions do not comply <span>to</span> <span
                                class="themeColor">with</span> this pathway.</p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>技術專有名詞的拼寫</h4>
                        <p>It was full of
                            <span>turgid</span>
                            <span class="themeColor">turbid</span> water and on analysis, the contamination levels were found to be very high.</p>
                    </div>
                    <a class="carousel-control-prev" href="#subject-verb-d" data-slide="prev">
                        <span>
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#subject-verb-d" data-slide="next">
                        <span>
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="or-spacer">
                <!-- <div class="mask"></div> -->
            </div>
        </div>
    </div>
</div>


<div class="academic_writing_section beyond_grammer_spelling_sections footer_shap_background">
    <div class="container">

        <div class="academic_slider_section">
            <div id="spelling_grammers" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>在文法和拼寫之上改善寫作</h3>
                    <p>除了文法，Trinka還可以提高您的詞彙、語調、句法等等。有了
                        <span class="OpenSansFonts">Trinka</span>，您可自信地表達自己的觀點。</p>
                    <ul class="carousel-indicators">
                        <li data-target="#spelling_grammers" data-slide-to="0" class="active">
                            <i>
                                <img src="../../../assets/images/style_guides_icon.png" alt="Style guides">
                            </i>
                            風格指南
                            <b class="OpenSansFonts">（APA | AMA）</b>
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="1">
                            <i>
                                <img src="../../../assets/images/scientific_tone_icon.png" alt="Scientific tone" />
                            </i>
                            學術語調
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="2">
                            <i>
                                <img src="../../../assets/images/technical_word_choice_icon.png" alt="Technical word choice" />
                            </i>
                            技術專有名詞選擇
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="3">
                            <i>
                                <img src="../../../assets/images/word_count_reduction_icon.png" alt="Word count reduction" />
                            </i>
                            簡明
                        </li>
                    </ul>


                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>風格指南偏好</h4>
                        <p>The
                            <span>males</span>
                            <span class="themeColor">men</span> scored higher than the
                            <span>females</span>
                            <span class="themeColor">women.</span>
                        </p>
                        <!-- <p>This system <span>is comprised of</span> <span class="themeColor">comprises</span> two
                            separate holding fixtures for the head.</p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>正式語氣</h4>
                        <p>However, this method is novel and is
                            <span>very much</span>
                            <span class="themeColor">significantly</span> different from the classical method.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>技術專有名詞選擇</h4>
                        <p>The CNTs also could enhance the resistance to photo degradation by UV irradiation during
                            <span>cyclical</span>
                            <span class="themeColor">cyclic</span> ageing tests.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>簡明</h4>
                        <p>Studies
                            <span>were carried out to evaluate</span>
                            <span class="themeColor"> evaluated</span> the effect of lower temperatures on energy consumption.
                        </p>
                    </div>
                    <a class="carousel-control-prev" href="#spelling_grammers" data-slide="prev">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#spelling_grammers" data-slide="next">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="or-spacer">
                <!-- <div class="mask"></div> -->
            </div>
        </div>
    </div>
</div>



<div class="academic_writing_section beyond_grammer_spelling_sections suggests_corrections_slider">
    <div class="container">

        <div class="academic_slider_section">
            <div id="suggests_corrections" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>依您專業作更改建議</h3>
                    <p>
                        <span class="OpenSansFonts">Trinka</span>從每門學科最好的論文中學習，為您提供最佳建議。使用
                        <span class="OpenSansFonts">Trinka</span>，給您精准的寫作。</p>
                    <span class="top_diviedLine"></span>
                    <ul class="carousel-indicators">
                        <li data-target="#suggests_corrections" data-slide-to="0" class="active">
                            <!-- <a><img src="../../../assets/images/medicine.png" class="img-fluid" /></a>  -->
                            <i>醫學</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="1">
                            <!-- <a><img src="../../../assets/images/biology.png" class="img-fluid" /></a>  -->
                            <i>生物學</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="2">
                            <!-- <a><img src="../../../assets/images/physics-icons.png" class="img-fluid" /></a>  -->
                            <i>物理</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="3">
                            <!-- <a><img src="../../../assets/images/social-science.png" class="img-fluid" /></a>  -->
                            <i>社會科學</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="4">
                            <!-- <a><img src="../../../assets/images/engineering.png" class="img-fluid" /></a>  -->
                            <i>工程</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="5">
                            <!-- <a><img src="../../../assets/images/chemistry.png" class="img-fluid" /></a>  -->
                            <i>化學</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="6">
                            <!-- <a><img src="../../../assets/images/geology.png" class="img-fluid" /></a>  -->
                            <i>地質學</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="7">
                            <!-- <a><img src="../../../assets/images/computer-science.png" class="img-fluid" /></a>  -->
                            <i>電腦科學</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="8">
                            <!-- <a><img src="../../../assets/images/business-and-economics.png" class="img-fluid" /></a> -->
                            <i>經濟學</i>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>醫學</h4>
                        <p>In general, the ADT group had a more
                            <span>advance</span>
                            <span class="themeColor">advanced</span> disease compared with the non-ADT group.
                        </p>
                        <!-- <p><span>Trinka</span> is your personal <span> AI editor</span> for all your academic writing
                            needs. <span>Trinka </span> is your personal <span> AI editor</span> for all your
                            <span>academic</span></p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>醫學</h4>
                        <!-- <p>A current is sent through the material; consequently polarizing the electrons are polarized.</p> -->
                        <p>The membranes were then incubated with human cleaved caspase-3 antibodies at 4°C
                            <span>for</span> overnight.</p>
                        <!-- <p><span>Trinka</span> is your personal <span> AI editor</span> for all your academic writing
                            needs. <span>Trinka </span> is your personal <span> AI editor</span> for all your
                            <span>academic</span></p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>物理</h4>
                        <p>Scientists rely on exactly
                            <span>soluble</span>
                            <span class="themeColor">solvable</span> problems to describe the strange effects which have quantum mechanical origin.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>社會科學</h4>
                        <p>The individual displayed
                            <span>a persistent spirit</span>
                            <span class="themeColor">persistence.</span>
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>工程</h4>
                        <p>The technique has
                            <span class="themeColor">been</span> widely used for the fabrication of SiC
                            <span>fiber</span>
                            <span class="themeColor">fibers</span> with high mechanical properties.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>化學</h4>
                        <p>A current is sent through the material, consequently
                            <span class="themeColor">polarizing</span> the electrons.
                            <span>are polarized.</span>
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>地質學</h4>
                        <p>
                            There was
                            <span class="themeColor">a</span> large tectonic movement at the end of the Mesozoic
                            <span>period</span>
                            <span class="themeColor">era</span>.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>電腦科學</h4>
                        <p>In
                            <span class="themeColor">the</span> testing phase,
                            <span>it's</span>
                            <span class="themeColor">its</span> label is determined using the
                            <span>triaining</span>
                            <span class="themeColor">training</span> instances mapped to a specific neuron.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>經濟學</h4>
                        <p>The role expected
                            <span>to</span>
                            <span class="themeColor">of</span> IASB has changed when it became a member of the Financial Stability Board in 2009.</p>
                    </div>

                    <a class="carousel-control-prev" href="#suggests_corrections" data-slide="prev">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#suggests_corrections" data-slide="next">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="purple-bg1 footer_shap_background">
    <div class="purple_background_overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <!-- wow fadeInLeft -->
                <div class="box">
                    <h3>
                        <span class="OpenSansFonts">Trinka</span>提供了最好的文章增強功能</h3>
                    <div class="box_text_content">
                        <p>
                            <span class="OpenSansFonts">Trinka</span>專為學術和技術寫作設計，它吸收了經驗豐富的編輯和語言學家的專業知識。 結果顯而易見——它是最好的語言增強工具。</p>
                    </div>
                    <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']" routerLinkActive="active" class="white-btn">下載白皮書</a>
                </div>
            </div>
            <div class="col-lg-6">
                <!-- wow fadeInLeft -->
                <div class="box">
                    <h3>
                        <span class="OpenSansFonts">Trinka</span>非常適合團隊和企業</h3>
                    <div class="box_text_content">
                        <p>讓您的團隊使用
                            <span class="OpenSansFonts">Trinka</span>提升寫作，並獲得優惠的價格和其他福利。</p>
                        <a [routerLink]="['/enterprise']">想要知道更多
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve">
                                <path d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                   C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                   c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"
                                />
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </a>
                    </div>
                    <div class="contact-sales">
                        <!-- <a class="white-btn">聯繫業務</a> -->
                        <button type="submit" id="contactSaleButton" (click)="sectionValue('Enterprise Form')" data-toggle="modal" data-target="#HomeContactPopup"
                            class="btn btn-primary mb-2">聯繫業務</button>
                        <!-- <form class="form-inline" id="contact-sales" [formGroup]="contactToSalesForm" (ngSubmit)="contactToSales()">
                            <div class="form-group"
                            [ngClass]="(!contactToSalesForm.get('saleFormemail').valid && contactToSalesForm.get('saleFormemail').dirty) || (contactToSalesForm.get('saleFormemail').touched && contactToSalesForm.get('saleFormemail').pristine) ? 'TextFiledError' : ''  ">
                                <mat-form-field appearance="outline">
                                    <mat-label>請輸入你的電子郵箱位址</mat-label>
                                    <input matInput placeholder="" formControlName="saleFormemail"
                                        class="form-control">
                                </mat-form-field>
                            </div>
                            <button type="submit" class="btn btn-primary mb-2">聯繫業務</button>
                        </form> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center testi">
                <h2 class="sub-head">使用感言</h2>
                <p>查看用戶對Trinka的評價</p>
            </div>
        </div>
    </div>
</div>


<div class="testimonial text-center">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="testimonial-wrap">
                    <!-- <div class="testimonal-icon">
                        <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                    </div> -->
                    <div class="testimonial-slider">
                        <div id="testi" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#testi" data-slide-to="0" class="active"></li>
                                <li data-target="#testi" data-slide-to="1"></li>
                                <li data-target="#testi" data-slide-to="2"></li>
                                <li data-target="#testi" data-slide-to="3"></li>
                                <li data-target="#testi" data-slide-to="4"></li>
                                <li data-target="#testi" data-slide-to="5"></li>
                                <li data-target="#testi" data-slide-to="6"></li>
                                <li data-target="#testi" data-slide-to="7"></li>
                                <li data-target="#testi" data-slide-to="8"></li>
                                <li data-target="#testi" data-slide-to="9"></li>
                                <li data-target="#testi" data-slide-to="10"></li>
                                <li data-target="#testi" data-slide-to="11"></li>
                                <li data-target="#testi" data-slide-to="12"></li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="James-Smith">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">我一下就愛上Trinka了。祝賀你們開發出這個可以大幅協助編輯的程式，尤其是符合重要的文法慣例和具備精簡字數功能的工具。
                                                </p>
                                                <p class="authorNameText">James Smith</p>
                                                <span class="authorDesignationText">學術編輯, 美國</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="Rosa-Diaz-Sandoval">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">對於說其他語言的人來說，用正確的英語文法和風格編寫文章不是一件容易的事。如果沒有協助工具，尤其是學術寫作，很難在文件中發現小錯誤。我嘗試將TrinkaAI作為自動校正工具，並對建議的更正和回饋感到非常滿意。通過回饋，能瞭解為什麼必須考慮建議的更改。</p>
                                                <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                <span class="authorDesignationText">物理和數學博士, 墨西哥</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="Dr_Farooq_Rathore">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">我使用Trinka兩個多月了。我主要用它來改進我為國內和國際生物醫學期刊撰寫的科學手稿的語言、文法和句法。介面很使用者友好，並且軟件高效且好用。根據需要編輯手稿的不同選項有助於決定我需要關注的地方。自動編輯的幫助很大，帶有修訂歷史的補充頁面很有用。Trinka一直在更新，我寫這篇文章時就注意到添加了一個新功能“一致性”。最好的是所有這些都是完全免費的。我強烈鼓勵作者和研究人員，特別是那些英語不好的人嘗試一下，親眼目睹驚人的結果。</p>
                                                <p class="authorNameText">Farooq Rathore博士</p>
                                                <span class="authorDesignationText">
                                                    助理教授兼系主任, 巴基斯坦</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jfif" alt="Georgieva-Milena">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Trinka.ai是我最喜歡的文法和拼寫編輯。該應用程式使用效果好，快速而明確！完全滿意！</p>
                                                <p class="authorNameText">Milena Georgieva</p>
                                                <span class="authorDesignationText">研究員</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="Dinesh Gupta">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">這是一個超越Grammarly的文法檢查工具！我用Trinka重新檢查了用Grammarly檢查過一些文檔。看到來自印度的如此優越產品，我感到非常驚喜！</p>
                                                <p class="authorNameText">Dinesh Gupta</p>
                                                <span class="authorDesignationText">放射科醫師, 印度</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="Edith-Davies">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">我已經測試過Trinka，並對其出色的功能印象深刻。它比我使用的文法檢查器做得更好。做得好！我已經告訴我研究實驗室的同事使用Trinka。希望在學術界得到廣泛應用。</p>
                                                <p class="authorNameText">Edith Davies</p>
                                                <span class="authorDesignationText">博士生, 英國</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="Noor-Al-rishi">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Trinka AI建議的更正和回饋令我驚喜。使用簡單，非常有益。</p>
                                                <p class="authorNameText">Noor Al-rishi</p>
                                                <span class="authorDesignationText">化學學者, 沙烏地阿拉伯</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="Nwaji-Jude">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">使用Trinka是美妙的體驗，如果不使用它評估稿件，我幾乎無法提交任何手稿。總之，Trinka成了我的是救命稻草。</p>
                                                <p class="authorNameText">Nwaji Jude</p>
                                                <span class="authorDesignationText">研究員</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="Stumpf-Curtis">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">我喜歡使用Trinka作為我編輯文稿的最終檢查。它確實有助於找到在編輯過程中漏掉的剩餘錯誤。我真的很喜歡這個平台。大拇指向下這個按鈕非常有用。
                                                </p>
                                                <p class="authorNameText">Stumpf Curtis</p>
                                                <span class="authorDesignationText">研究員</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="Dyke-Gareth">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">我認為Trinka.ai 是一個非常有趣且很有發展潛力的主意，尤其是對於編輯/出版社/期刊。我使用這個平台檢查我的編輯工作，非常有用。</p>
                                                <p class="authorNameText">Gareth Dyke</p>
                                                <span class="authorDesignationText">研究員</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="Bhargava Sharma">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">我對整體表現感到滿意。我使用Grammarly已經有很長一段時間了，但是在學術或技術寫作方面，Trinka絕對是更好的選擇。學術文件設置和自動文件編輯是我最喜歡的功能。</p>
                                                <p class="authorNameText">Bhargava Sharma</p>
                                                <span class="authorDesignationText">流行病學家, 印度</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="Ralph-Bailey">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Trinka已成為我文法校正的首選工具。人工智慧驅動的更正和語言增強使寫作變得更加容易。現在，我可以更專注於研究，而不是糾正文稿中的錯誤。</p>
                                                <p class="authorNameText">Ralph Bailey</p>
                                                <span class="authorDesignationText">神經科醫生, 美國</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="Thomas-Andres">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">基於AMA風格指南的文法糾正和建議真的令人印象深刻！Trinka確實是醫學寫作最好的文法校正工具。
                                                </p>
                                                <p class="authorNameText">Thomas Andres</p>
                                                <span class="authorDesignationText">心臟學專家, 巴西</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                            <span class="carousel-control-prev-icon"></span>
                        </a>
                        <a class="carousel-control-next" href="#testi" data-slide="next">
                            <span class="carousel-control-next-icon"></span>
                        </a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="client_rating_logo">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-3">
                <div class="client_rating_text">
                    <h2>獲得全球用戶<br />高度評價</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="client_logo_right">
                    <div class="row">
                        <div class="col-md-3 col-6">
                            <div class="client-rating sourceforge">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/SourceForge_logo.png"  />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating trustpilot">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/trustpilot-1.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star"></i></li>
                                </ul>
                                <p>4 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating product-hunt">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/product-hunt.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating g2">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/G2_Crowd.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating capterra">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/capterra-inc.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating chrome-tool">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/chrome.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star-half-o active"></i></li>
                                </ul>
                                <p>4.3 out of 5</p>
                            </div>
                        </div>
                        
                        
                        <div class="col-md-3 col-6">
                            <div class="client-rating trustradius">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/trust-radius.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star-half-o active"></i></li>
                                </ul>
                                <p>8.4 out of 10</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating software-suggest">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/softwaresuggest-social.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal custom_modal_popup enterprisePopup" id="HomeContactPopup">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
                <div class="closed_icons">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="contactPopupHeading">
                            <h2>企業客戶諮詢</h2>
                            <p *ngIf="formSection">誰需要我們的服務？</p>
                        </div>
                    </div>
                    <div class="inquiryTypeSection">
                        <ul class="nav nav-tabs" role="tablist" *ngIf="formSection">
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#IndividualType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Individual">
                                            <path class="cls-1" d="M44.83,45.13V39.82a4.65,4.65,0,0,0-1.7-3.6,62.85,62.85,0,0,0-10.89-7V22.5a4.4,4.4,0,0,0,1.56-3.36V11.39A7.9,7.9,0,0,0,25.91,3.5H24.24a7.9,7.9,0,0,0-7.89,7.89v7.75a4.32,4.32,0,0,0,1.54,3.36h0v6.68A62.22,62.22,0,0,0,7,36.22a4.62,4.62,0,0,0-1.7,3.6v5.31"
                                            />
                                        </g>
                                    </svg>
                                    <div class="text-left">
                                        <h3>個人用戶</h3>
                                        <span>（單一使用者）</span>
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#OrganizationType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Organization">
                                            <path class="cls-1" d="M42.87,45.13V40.06a4.45,4.45,0,0,0-1.62-3.44,60,60,0,0,0-10.41-6.72V23.51a4.2,4.2,0,0,0,1.49-3.21V12.89a7.55,7.55,0,0,0-7.54-7.54H23.19a7.55,7.55,0,0,0-7.54,7.54V20.3a4.13,4.13,0,0,0,1.47,3.21h0v6.38A59.44,59.44,0,0,0,6.71,36.62a4.42,4.42,0,0,0-1.62,3.44v5.07"
                                            />
                                            <path class="cls-1" d="M14.34,30.75a24.56,24.56,0,0,0-3.32-2V26.18a1.66,1.66,0,0,0,.59-1.27V22a3,3,0,0,0-3-3H8a3,3,0,0,0-3,3v2.93a1.63,1.63,0,0,0,.58,1.27h0v2.53a23.54,23.54,0,0,0-4.12,2.66,1.75,1.75,0,0,0-.64,1.36v2"
                                            />
                                            <path class="cls-1" d="M34.29,30.75a24.56,24.56,0,0,1,3.32-2V26.18A1.66,1.66,0,0,1,37,24.91V22a3,3,0,0,1,3-3h.63a3,3,0,0,1,3,3v2.93A1.63,1.63,0,0,1,43,26.18h0v2.53a23.54,23.54,0,0,1,4.12,2.66,1.75,1.75,0,0,1,.64,1.36v2"
                                            />
                                        </g>
                                    </svg>
                                    <div class="text-left">
                                        <h3>企業或單位</h3>
                                        <span>（多個用戶）</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane" id="IndividualType" role="tabpanel" *ngIf="formSection">
                                <div class="IndividualTypeSection">
                                    <p>Trinka對於個人用戶是免費的，您只需註冊您的電子郵箱地址即可。</p>
                                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費註冊</a>
                                </div>
                            </div>
                            <div class="tab-pane" id="OrganizationType" role="tabpanel" *ngIf="formSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="contact_us_form">
                                            <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                                                <h2>請在下面提出您的要求，我們的團隊將及時回復。</h2>
                                                <div class="row">
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('NatureBusinessType').valid && contactForm.get('NatureBusinessType').dirty) || (contactForm.get('NatureBusinessType').touched && contactForm.get('NatureBusinessType').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>業務性質*</mat-label>
                                                                <input matInput placeholder="" formControlName="NatureBusinessType" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>單位名稱*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormSubjects" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="textbox_content form-group textareaBox" [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                            <label for="">請告訴我們您的要求</label>
                                                            <textarea formControlName="contactFormMessage" class="form-control" placeholder="例如。大約的用戶數，每個用戶的每月處理字數，所需的自訂設置等。"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>您的姓名*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('DesignationTypes').valid && contactForm.get('DesignationTypes').dirty) || (contactForm.get('DesignationTypes').touched && contactForm.get('DesignationTypes').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>指定*</mat-label>
                                                                <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>電子郵件*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactphoneNo').valid && contactForm.get('contactphoneNo').dirty) || (contactForm.get('contactphoneNo').touched && contactForm.get('contactphoneNo').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>聯絡電話（包括國際代碼）</mat-label>
                                                                <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group text-center">
                                                    <button type="submit">送出</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="thank_section contact_us_form" *ngIf="thankSection">
                                <div class="form-group">
                                    <h2>感謝您！</h2>
                                    <p>我們會儘快和您聯絡。</p>
                                    <!-- <button data-dismiss="modal">Close</button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>